<!-- 文档中心 -->
<template>
  <div class="">
    <headerBar v-on:userInfo="emitUserInfo" />
    <div class="ysc_banner">
      <div class="c_banner_txt wow fadeInDown">
        <div class="c_banner_tit">文档中心</div>
      </div>
    </div>
    <Layout class="ysc_index_content">
      <Sider hide-trigger :style="{background: '#f9f9f9'}">
        <Menu active-name="sfs" width="auto" :style="{background: '#f9f9f9', textAlign: 'center'}"
          @on-select="menuSelect">
          <MenuItem :name="side.name" v-for="side in documentsData" :key="side.name">{{side.nameTxt}}</MenuItem>
        </Menu>
      </Sider>
      <Content v-for="row in documentsData" :key="row.name" v-if="menuActive == row.name">
        <RadioGroup v-model="proButtons" type="button" style="padding: 20px;">
          <Radio label="1">产品介绍</Radio>
          <Radio label="2" v-if="userPin">产品使用手册</Radio>
        </RadioGroup>
        <div>
          <embed height="890px"
            width="100%"
            style="display: block;"
            :src="proButtons == '1' ? '/newprotal/img/' + row.proInfo : '/newprotal/img/' + row.proHandler"
            type="application/pdf">
        </div>
      </Content>
    </Layout>
    <footerBar/>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import IndexFetch from '@/request/index'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    headerBar: () => import("../components/headerBar/HeaderBar.vue"),
    footerBar: () => import("../components/footer/Footer.vue"),
  },
  data() {
    //这里存放数据
    return {
      userPin: false,
      menuActive: 'sfs',
      proButtons: '1', // 产品介绍 or 产品使用手册
      documentsData: [
        {
          name: 'sfs',
          nameTxt: '销量计划',
          proInfo: 'sfs-pro.pdf',
          proHandler: 'sfs-handler.pdf',
        },
        {
          name: 'pbs',
          nameTxt: '智能补货',
          proInfo: 'pbs-pro.pdf',
          proHandler: 'pbs-handler.pdf',
        },
        {
          name: 'vrs',
          nameTxt: '滞销处理',
          proInfo: 'vrs-pro.pdf',
          proHandler: 'vrs-handler.pdf',
        },
        {
          name: 'il',
          nameTxt: '存货布局',
          proInfo: 'il-pro.pdf',
          proHandler: 'il-handler.pdf',
        },
        {
          name: 'ihs',
          nameTxt: '库存健康',
          proInfo: 'ihs-pro.pdf',
          proHandler: 'ihs-handler.pdf',
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    emitUserInfo (userInfo) {
      if (userInfo && userInfo.userPin) {
        this.userPin = true
      }
    },
    menuSelect (name) {
      // console.log(name)
      this.menuActive = name
      this.proButtons = '1' // 产品介绍 or 产品使用手册
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../assets/scss/yscIndex";
@import "../../../assets/muss/muss";

.ysc_banner{
  background: #000 url('../../../assets/images/tbg1.png') top center no-repeat;
  background-size: cover;
  .c_banner_txt{
    padding-top: 180px;
  }
  .c_banner_tit{
    font-size: 36px;
  }
}
</style>
